import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

import { PageElement } from './Page';

const WorkOrder = lazy(() =>
    import('@/v1/management/views/WorkOrder').then((module) => ({
        default: module.WorkOrder,
    }))
);

export const eventRoutes: RouteObject[] = [
    {
        path: `work_order/:mode?`,
        ...PageElement(<WorkOrder />),
    },
];
